// SEO meta + H1 for localized landing pages (3 variants × 26 langs)
// Variants: ai-visibility (GEO/AI search), outrank (beat competitors), free-scan (audit lead-gen)
// Slugs stay English (universal URL) — meta/H1/body localized.
export const landingSeoTranslations = {
  en: {
    // ai-visibility
    lp_aiv_title: "AI Visibility Tracker — Be Cited in ChatGPT, Perplexity & Gemini | TopRankPulse",
    lp_aiv_desc: "Monitor, measure, and grow your brand's visibility in AI answer engines. Free scan, no credit card — see how often ChatGPT mentions you vs. your competitors.",
    lp_aiv_h1_a: "Is your brand",
    lp_aiv_h1_b: "invisible to AI?",
    lp_aiv_lead: "93% of buying decisions now start on ChatGPT, Perplexity or Gemini. See where your brand ranks — and how to get cited in 7 days.",
    lp_aiv_cta: "Run free AI visibility scan",
    // outrank
    lp_out_title: "Outrank Your Competitor in 30 Days — AI Strategy Generator | TopRankPulse",
    lp_out_desc: "Enter your domain + a competitor. Get a concrete 4-week action plan (SEO + GEO) powered by GPT — weekly tasks, unfair advantages, 30-day forecast.",
    lp_out_h1_a: "Outrank",
    lp_out_h1_b: "any competitor",
    lp_out_h1_c: "in 30 days",
    lp_out_lead: "No guesswork. Get a personalized, AI-generated battle plan tailored to YOUR domain vs. THEIRS — ready in 15 seconds.",
    lp_out_cta: "Generate my 30-day plan",
    // free-scan
    lp_scan_title: "Free SEO + AI Scan — Full Audit in 30 Seconds | TopRankPulse",
    lp_scan_desc: "Paste your URL → get an instant SEO + GEO + AI visibility audit with 3 concrete fixes from PulseAI Engine™. 100% free, no credit card.",
    lp_scan_h1_a: "Full audit in",
    lp_scan_h1_b: "30 seconds",
    lp_scan_lead: "SEO + GEO + AI visibility in a single scan. 3 copy-paste fixes, delivered by PulseAI Engine™ in your language.",
    lp_scan_cta: "Run my free scan",
  },
  sk: {
    lp_aiv_title: "AI Visibility Tracker — Buď citovaný v ChatGPT, Perplexity & Gemini | TopRankPulse",
    lp_aiv_desc: "Sleduj, meraj a zvýš viditeľnosť tvojej značky v AI odpovediach. Bezplatný scan bez kreditky — zisti, ako často ChatGPT spomína teba vs. konkurenciu.",
    lp_aiv_h1_a: "Je tvoja značka",
    lp_aiv_h1_b: "neviditeľná pre AI?",
    lp_aiv_lead: "93% nákupných rozhodnutí dnes začína v ChatGPT, Perplexity alebo Gemini. Pozri, kde stojíš — a ako sa dostať do AI odpovedí do 7 dní.",
    lp_aiv_cta: "Spusti bezplatný AI scan",
    lp_out_title: "Prekonaj konkurenta za 30 dní — AI Stratégia | TopRankPulse",
    lp_out_desc: "Zadaj tvoju doménu + konkurenta. Získaj konkrétny 4-týždňový akčný plán (SEO + GEO) poháňaný GPT — týždenné úlohy, neférové výhody, 30-dňová predpoveď.",
    lp_out_h1_a: "Prekonaj",
    lp_out_h1_b: "akéhokoľvek konkurenta",
    lp_out_h1_c: "za 30 dní",
    lp_out_lead: "Bez hádania. Personalizovaný AI battle plan ušitý na TVOJU doménu vs. KONKURENTA — pripravený za 15 sekúnd.",
    lp_out_cta: "Vygenerovať 30-dňový plán",
    lp_scan_title: "Bezplatný SEO + AI Scan — Kompletný audit za 30 sekúnd | TopRankPulse",
    lp_scan_desc: "Vlož URL → okamžitý SEO + GEO + AI visibility audit s 3 konkrétnymi riešeniami od PulseAI Engine™. 100% zadarmo, bez kreditky.",
    lp_scan_h1_a: "Kompletný audit za",
    lp_scan_h1_b: "30 sekúnd",
    lp_scan_lead: "SEO + GEO + AI visibility v jednom scane. 3 copy-paste riešenia od PulseAI Engine™ priamo v tvojom jazyku.",
    lp_scan_cta: "Spusti bezplatný scan",
  },
  cs: {
    lp_aiv_title: "Nástroj pro sledování viditelnosti AI — Buďte citováni v ChatGPT, Perplexity a Gemini | TopRankPulse",
    lp_aiv_desc: "Sledujte, měřte a zvyšujte viditelnost vaší značky v AI vyhledávačích. Bezplatný sken, žádná kreditní karta — zjistěte, jak často vás ChatGPT zmiňuje ve srovnání s vašimi konkurenty.",
    lp_aiv_h1_a: "Je vaše značka",
    lp_aiv_h1_b: "neviditelná pro AI?",
    lp_aiv_lead: "93 % nákupních rozhodnutí nyní začíná na ChatGPT, Perplexity nebo Gemini. Zjistěte, jak si vaše značka stojí — a jak být citován během 7 dní.",
    lp_aiv_cta: "Spustit bezplatný sken viditelnosti AI",
    lp_out_title: "Překonejte svého konkurenta za 30 dnů — Generátor AI strategie | TopRankPulse",
    lp_out_desc: "Zadejte svou doménu + konkurenta. Získejte konkrétní akční plán na 4 týdny (SEO + GEO) poháněný GPT — týdenní úkoly, neférové výhody, 30denní prognóza.",
    lp_out_h1_a: "Překonejte",
    lp_out_h1_b: "jakéhokoli konkurenta",
    lp_out_h1_c: "za 30 dnů",
    lp_out_lead: "Žádné hádání. Získejte personalizovaný, AI-generovaný bojový plán přizpůsobený VAŠÍ doméně proti TÉ VAŠÍ — připraveno za 15 sekund.",
    lp_out_cta: "Vygenerovat můj 30denní plán",
    lp_scan_title: "Bezplatný SEO + AI sken — Kompletní audit za 30 sekund | TopRankPulse",
    lp_scan_desc: "Vložte svou URL → získejte okamžitý audit SEO + GEO + AI viditelnosti s 3 konkrétními opravami od PulseAI Engine™. 100 % zdarma, žádná kreditní karta.",
    lp_scan_h1_a: "Kompletní audit za",
    lp_scan_h1_b: "30 sekund",
    lp_scan_lead: "SEO + GEO + AI viditelnost v jednom skenu. 3 opravy na zkopírování a vložení, dodané PulseAI Engine™ ve vaší řeči.",
    lp_scan_cta: "Spustit můj bezplatný sken",
  },
  de: {
    lp_aiv_title: "AI Sichtbarkeitstracker — In ChatGPT, Perplexity & Gemini zitiert werden | TopRankPulse",
    lp_aiv_desc: "Überwachen, messen und steigern Sie die Sichtbarkeit Ihrer Marke in AI-Antomotoren. Kostenloser Scan, keine Kreditkarte erforderlich — sehen Sie, wie oft ChatGPT Sie im Vergleich zu Ihren Wettbewerbern erwähnt.",
    lp_aiv_h1_a: "Ist Ihre Marke",
    lp_aiv_h1_b: "für AI unsichtbar?",
    lp_aiv_lead: "93% der Kaufentscheidungen beginnen jetzt auf ChatGPT, Perplexity oder Gemini. Erfahren Sie, wo Ihre Marke steht — und wie Sie innerhalb von 7 Tagen zitiert werden.",
    lp_aiv_cta: "Kostenlosen AI-Sichtbarkeitsscan durchführen",
    lp_out_title: "Übertreffen Sie Ihren Wettbewerb in 30 Tagen — AI-Strategiegenerator | TopRankPulse",
    lp_out_desc: "Geben Sie Ihre Domain + einen Wettbewerber ein. Erhalten Sie einen konkreten 4-wöchigen Aktionsplan (SEO + GEO), powered by GPT — wöchentliche Aufgaben, unfaire Vorteile, 30-Tage-Prognose.",
    lp_out_h1_a: "Übertreffen",
    lp_out_h1_b: "jeden Wettbewerber",
    lp_out_h1_c: "in 30 Tagen",
    lp_out_lead: "Keine Stichproben. Erhalten Sie einen personalisierten, AI-generierten Kampfplan, der auf IHRE Domain im Vergleich zu DEREN zugeschnitten ist — in 15 Sekunden bereit.",
    lp_out_cta: "Mein 30-Tage-Plan generieren",
    lp_scan_title: "Kostenloser SEO + AI Scan — Vollständiger Audit in 30 Sekunden | TopRankPulse",
    lp_scan_desc: "Fügen Sie Ihre URL ein → erhalten Sie einen sofortigen SEO + GEO + AI Sichtbarkeits-Audit mit 3 konkreten Lösungen vom PulseAI Engine™. 100% kostenlos, keine Kreditkarte notwendig.",
    lp_scan_h1_a: "Vollständiger Audit in",
    lp_scan_h1_b: "30 Sekunden",
    lp_scan_lead: "SEO + GEO + AI Sichtbarkeit in einem einzigen Scan. 3 Copy-Paste-Lösungen, geliefert von PulseAI Engine™ in Ihrer Sprache.",
    lp_scan_cta: "Meinen kostenlosen Scan durchführen",
  },
  pl: {
    lp_aiv_title: "Śledzenie widoczności AI — Bądź cytowany w ChatGPT, Perplexity i Gemini | TopRankPulse",
    lp_aiv_desc: "Monitoruj, mierz i rozwijaj widoczność swojej marki w silnikach odpowiedzi AI. Darmowe skanowanie, bez karty kredytowej — sprawdź, jak często ChatGPT wspomina o Tobie w porównaniu do konkurencji.",
    lp_aiv_h1_a: "Czy Twoja marka",
    lp_aiv_h1_b: "jest niewidoczna dla AI?",
    lp_aiv_lead: "93% decyzji zakupowych zaczyna się teraz w ChatGPT, Perplexity lub Gemini. Zobacz, jakie masz miejsce w rankingu — i jak zdobyć cytaty w 7 dni.",
    lp_aiv_cta: "Uruchom darmowe skanowanie widoczności AI",
    lp_out_title: "Wyprzedź swojego konkurenta w 30 dni — Generator strategii AI | TopRankPulse",
    lp_out_desc: "Wprowadź swoją domenę + konkurenta. Otrzymaj konkretny 4-tygodniowy plan działania (SEO + GEO) oparty na GPT — cotygodniowe zadania, niesprawiedliwe przewagi, prognoza na 30 dni.",
    lp_out_h1_a: "Wyprzedź",
    lp_out_h1_b: "dowolnego konkurenta",
    lp_out_h1_c: "w 30 dni",
    lp_out_lead: "Bez zgadywania. Otrzymaj spersonalizowany, wygenerowany przez AI plan bitwy dostosowany do TWOJEJ domeny w porównaniu do ICH — gotowy w 15 sekund.",
    lp_out_cta: "Generuj mój plan na 30 dni",
    lp_scan_title: "Darmowe skanowanie SEO + AI — Pełny audyt w 30 sekund | TopRankPulse",
    lp_scan_desc: "Wklej swój URL → otrzymaj natychmiastowy audyt SEO + GEO + widoczności AI z 3 konkretnymi poprawkami z silnika PulseAI™. 100% za darmo, bez karty kredytowej.",
    lp_scan_h1_a: "Pełny audyt w",
    lp_scan_h1_b: "30 sekund",
    lp_scan_lead: "SEO + GEO + widoczność AI w jednym skanowaniu. 3 poprawki do skopiowania i wklejenia, dostarczone przez silnik PulseAI™ w Twoim języku.",
    lp_scan_cta: "Uruchom moje darmowe skanowanie",
  },
  hu: {
    lp_aiv_title: "AI Láthatóság Követő — Legyél említve a ChatGPT, Perplexity & Gemini által | TopRankPulse",
    lp_aiv_desc: "Kövesd, mérd és növeld a márkád láthatóságát az AI válaszmotorokban. Ingyenes ellenőrzés, nincs hitelkártya — nézd meg, hányszor említ a ChatGPT a versenytársaidhoz képest.",
    lp_aiv_h1_a: "A márkád",
    lp_aiv_h1_b: "láthatatlan az AI számára?",
    lp_aiv_lead: "A vásárlási döntések 93%-a most a ChatGPT, Perplexity vagy Gemini platformról indul. Nézd meg, hol áll a márkád — és hogyan említhetnek 7 napon belül.",
    lp_aiv_cta: "Futtass ingyenes AI láthatósági vizsgálatot",
    lp_out_title: "Tartsd túl a versenytársadat 30 nap alatt — AI Stratégiagenerátor | TopRankPulse",
    lp_out_desc: "Add meg a doméned + egy versenytársat. Kapj egy konkrét 4 hetes cselekvési tervet (SEO + GEO) a GPT által támogatva — heti feladatok, tisztességtelen előnyök, 30 napos előrejelzés.",
    lp_out_h1_a: "Túllépés",
    lp_out_h1_b: "bármelyik versenytárson",
    lp_out_h1_c: "30 napon belül",
    lp_out_lead: "Nincs találgatás. Kapj egy személyre szabott, AI által generált harci tervet a TI doménedre és AZ ÖVÉRE — készen 15 másodperc alatt.",
    lp_out_cta: "Generálj 30 napos tervet",
    lp_scan_title: "Ingyenes SEO + AI Vizsgálat — Teljes Audit 30 Másodperc Alatt | TopRankPulse",
    lp_scan_desc: "Illeszd be az URL-ed → kapj egy azonnali SEO + GEO + AI láthatósági auditot 3 konkrét javítással a PulseAI Engine™-től. 100%-ban ingyenes, nincs hitelkártya.",
    lp_scan_h1_a: "Teljes audit",
    lp_scan_h1_b: "30 másodperc alatt",
    lp_scan_lead: "SEO + GEO + AI láthatóság egyetlen vizsgálatban. 3 másolható javítás, a PulseAI Engine™ által a te nyelveden.",
    lp_scan_cta: "Futtassam az ingyenes vizsgálatom",
  },
  fr: {
    lp_aiv_title: "Suivi de Visibilité AI — Soyez Cité dans ChatGPT, Perplexity & Gemini | TopRankPulse",
    lp_aiv_desc: "Surveillez, mesurez et développez la visibilité de votre marque dans les moteurs de réponse AI. Scan gratuit, pas de carte cruciale — voyez à quelle fréquence ChatGPT vous mentionne par rapport à vos concurrents.",
    lp_aiv_h1_a: "Votre marque est",
    lp_aiv_h1_b: "invisible pour l'IA ?",
    lp_aiv_lead: "93 % des décisions d'achat commencent maintenant sur ChatGPT, Perplexity ou Gemini. Voyez où se classe votre marque — et comment être cité en 7 jours.",
    lp_aiv_cta: "Lancez un scan gratuit de visibilité AI",
    lp_out_title: "Dépassez Votre Concurrent en 30 Jours — Générateur de Stratégie AI | TopRankPulse",
    lp_out_desc: "Entrez votre domaine + un concurrent. Obtenez un plan d'action concret de 4 semaines (SEO + GEO) alimenté par GPT — tâches hebdomadaires, avantages déloyaux, prévisions sur 30 jours.",
    lp_out_h1_a: "Dépassez",
    lp_out_h1_b: "n'importe quel concurrent",
    lp_out_h1_c: "en 30 jours",
    lp_out_lead: "Pas de conjectures. Obtenez un plan de bataille personnalisé, généré par AI, adapté à VOTRE domaine par rapport au LEUR — prêt en 15 secondes.",
    lp_out_cta: "Générez mon plan de 30 jours",
    lp_scan_title: "Scan SEO + AI Gratuit — Audit Complet en 30 Secondes | TopRankPulse",
    lp_scan_desc: "Collez votre URL → obtenez un audit instantané de visibilité SEO + GEO + AI avec 3 corrections concrètes de PulseAI Engine™. 100 % gratuit, pas de carte cruciale.",
    lp_scan_h1_a: "Audit complet en",
    lp_scan_h1_b: "30 secondes",
    lp_scan_lead: "Visibilité SEO + GEO + AI en un seul scan. 3 corrections à copier-coller, livrées par PulseAI Engine™ dans votre langue.",
    lp_scan_cta: "Lancez mon scan gratuit",
  },
  es: {
    lp_aiv_title: "Rastreador de Visibilidad AI — Sé citado en ChatGPT, Perplexity y Gemini | TopRankPulse",
    lp_aiv_desc: "Monitorea, mide y aumenta la visibilidad de tu marca en los motores de respuesta AI. Escaneo gratuito, sin tarjeta de crédito — descubre con qué frecuencia ChatGPT te menciona en comparación con tus competidores.",
    lp_aiv_h1_a: "¿Es tu marca",
    lp_aiv_h1_b: "invisible para la AI?",
    lp_aiv_lead: "El 93% de las decisiones de compra ahora comienzan en ChatGPT, Perplexity o Gemini. Ve cómo se posiciona tu marca — y cómo ser citado en 7 días.",
    lp_aiv_cta: "Realiza un escaneo gratuito de visibilidad AI",
    lp_out_title: "Supera a tu Competidor en 30 Días — Generador de Estrategia AI | TopRankPulse",
    lp_out_desc: "Ingresa tu dominio + un competidor. Obtén un plan de acción concreto de 4 semanas (SEO + GEO) impulsado por GPT — tareas semanales, ventajas injustas, pronóstico de 30 días.",
    lp_out_h1_a: "Supera a",
    lp_out_h1_b: "cualquier competidor",
    lp_out_h1_c: "en 30 días",
    lp_out_lead: "Sin conjeturas. Obtén un plan de batalla personalizado generado por AI adaptado a TU dominio vs. EL SUYO — listo en 15 segundos.",
    lp_out_cta: "Genera mi plan de 30 días",
    lp_scan_title: "Escaneo Gratuito SEO + AI — Auditoría Completa en 30 Segundos | TopRankPulse",
    lp_scan_desc: "Pega tu URL → obtén una auditoría instantánea de visibilidad SEO + GEO + AI con 3 correcciones concretas de PulseAI Engine™. 100% gratuito, sin tarjeta de crédito.",
    lp_scan_h1_a: "Auditoría completa en",
    lp_scan_h1_b: "30 segundos",
    lp_scan_lead: "Visibilidad SEO + GEO + AI en un solo escaneo. 3 correcciones para copiar y pegar, entregadas por PulseAI Engine™ en tu idioma.",
    lp_scan_cta: "Realiza mi escaneo gratuito",
  },
  pt: {
    lp_aiv_title: "Rastreador de Visibilidade em IA — Seja Citado no ChatGPT, Perplexity & Gemini | TopRankPulse",
    lp_aiv_desc: "Monitore, meça e aumente a visibilidade da sua marca nos motores de resposta em IA. Escaneamento gratuito, sem cartão de crédito — veja com que frequência o ChatGPT menciona você em comparação com seus concorrentes.",
    lp_aiv_h1_a: "Sua marca está",
    lp_aiv_h1_b: "invisível para IA?",
    lp_aiv_lead: "93% das decisões de compra agora começam no ChatGPT, Perplexity ou Gemini. Veja onde sua marca se classifica — e como ser citado em 7 dias.",
    lp_aiv_cta: "Realizar escaneamento gratuito de visibilidade em IA",
    lp_out_title: "Ultrapasse Seu Concorrente em 30 Dias — Gerador de Estratégia de IA | TopRankPulse",
    lp_out_desc: "Insira seu domínio + um concorrente. Obtenha um plano de ação concreto para 4 semanas (SEO + GEO) gerado por GPT — tarefas semanais, vantagens injustas, previsão de 30 dias.",
    lp_out_h1_a: "Ultrapasse",
    lp_out_h1_b: "qualquer concorrente",
    lp_out_h1_c: "em 30 dias",
    lp_out_lead: "Sem suposições. Obtenha um plano de batalha personalizado, gerado por IA, adaptado ao SEU domínio vs. O DELES — pronto em 15 segundos.",
    lp_out_cta: "Gerar meu plano de 30 dias",
    lp_scan_title: "Escaneamento Gratuito de SEO + IA — Auditoria Completa em 30 Segundos | TopRankPulse",
    lp_scan_desc: "Cole sua URL → obtenha uma auditoria instantânea de visibilidade SEO + GEO + IA com 3 correções concretas do PulseAI Engine™. 100% gratuito, sem cartão de crédito.",
    lp_scan_h1_a: "Auditoria completa em",
    lp_scan_h1_b: "30 segundos",
    lp_scan_lead: "Visibilidade SEO + GEO + IA em um único escaneamento. 3 correções de copiar e colar, entregues pelo PulseAI Engine™ na sua língua.",
    lp_scan_cta: "Executar meu escaneamento gratuito",
  },
  it: {
    lp_aiv_title: "Tracker di Visibilità AI — Fatti Citare in ChatGPT, Perplexity & Gemini | TopRankPulse",
    lp_aiv_desc: "Monitora, misura e fai crescere la visibilità del tuo brand nei motori di risposta AI. Scansione gratuita, senza carta di credito — scopri quante volte ChatGPT ti menziona rispetto ai tuoi concorrenti.",
    lp_aiv_h1_a: "Il tuo brand è",
    lp_aiv_h1_b: "invisibile per l'AI?",
    lp_aiv_lead: "Il 93% delle decisioni d'acquisto inizia ora su ChatGPT, Perplexity o Gemini. Scopri dove si posiziona il tuo brand — e come essere citato in 7 giorni.",
    lp_aiv_cta: "Esegui scansione visibilità AI gratuita",
    lp_out_title: "Sorpassa il Tuo Competitore in 30 Giorni — Generatore di Strategie AI | TopRankPulse",
    lp_out_desc: "Inserisci il tuo dominio + un concorrente. Ottieni un piano d'azione concreto di 4 settimane (SEO + GEO) alimentato da GPT — compiti settimanali, vantaggi ingiusti, previsioni a 30 giorni.",
    lp_out_h1_a: "Sorpassa",
    lp_out_h1_b: "qualsiasi concorrente",
    lp_out_h1_c: "in 30 giorni",
    lp_out_lead: "Nessuna congettura. Ricevi un piano di battaglia personalizzato, generato dall'AI, su MISURA per il TUO dominio rispetto al LORO — pronto in 15 secondi.",
    lp_out_cta: "Genera il mio piano di 30 giorni",
    lp_scan_title: "Scansione SEO + AI Gratuita — Audit Completo in 30 Secondi | TopRankPulse",
    lp_scan_desc: "Incolla il tuo URL → ottieni un'audit immediata di visibilità SEO + GEO + AI con 3 correzioni concrete da PulseAI Engine™. 100% gratuita, senza carta di credito.",
    lp_scan_h1_a: "Audit completo in",
    lp_scan_h1_b: "30 secondi",
    lp_scan_lead: "Visibilità SEO + GEO + AI in un'unica scansione. 3 correzioni pronte da copiare e incollare, consegnate da PulseAI Engine™ nella tua lingua.",
    lp_scan_cta: "Esegui la mia scansione gratuita",
  },
  nl: {
    lp_aiv_title: "AI Zichtbaarheid Tracker — Genoemd worden in ChatGPT, Perplexity & Gemini | TopRankPulse",
    lp_aiv_desc: "Monitor, meet en vergroot de zichtbaarheid van je merk in AI antwoordmachines. Gratis scan, geen creditcard — zie hoe vaak ChatGPT je noemt in vergelijking met je concurrenten.",
    lp_aiv_h1_a: "Is je merk",
    lp_aiv_h1_b: "onzichtbaar voor AI?",
    lp_aiv_lead: "93% van de aankoopbeslissingen begint nu op ChatGPT, Perplexity of Gemini. Zie waar je merk rankt — en hoe je binnen 7 dagen genoemd kunt worden.",
    lp_aiv_cta: "Voer gratis AI zichtbaarheid scan uit",
    lp_out_title: "Overtref je Concurrent in 30 Dagen — AI Strategie Generator | TopRankPulse",
    lp_out_desc: "Voer je domein + een concurrent in. Ontvang een concreet 4-weken actieplan (SEO + GEO) aangedreven door GPT — wekelijkse taken, oneerlijke voordelen, 30-dagen voorspelling.",
    lp_out_h1_a: "Overtref",
    lp_out_h1_b: "iedere concurrent",
    lp_out_h1_c: "in 30 dagen",
    lp_out_lead: "Geen gegok. Ontvang een gepersonaliseerd, AI-gegenereerd strijdplan op maat voor JOUW domein vs. HUNNE — klaar in 15 seconden.",
    lp_out_cta: "Genereer mijn 30-dagen plan",
    lp_scan_title: "Gratis SEO + AI Scan — Volledige Audit in 30 Seconden | TopRankPulse",
    lp_scan_desc: "Plak je URL → ontvang een instant SEO + GEO + AI zichtbaarheid audit met 3 concrete oplossingen van PulseAI Engine™. 100% gratis, geen creditcard.",
    lp_scan_h1_a: "Volledige audit in",
    lp_scan_h1_b: "30 seconden",
    lp_scan_lead: "SEO + GEO + AI zichtbaarheid in één scan. 3 copy-paste oplossingen, geleverd door PulseAI Engine™ in jouw taal.",
    lp_scan_cta: "Voer mijn gratis scan uit",
  },
  sv: {
    lp_aiv_title: "AI Synlighetsspårare — Bli nämnd i ChatGPT, Perplexity & Gemini | TopRankPulse",
    lp_aiv_desc: "Övervaka, mät och väx ditt varumärkes synlighet i AI-svarsmotorer. Gratis skanning, inget kreditkort — se hur ofta ChatGPT nämner dig jämfört med dina konkurrenter.",
    lp_aiv_h1_a: "Är ditt varumärke",
    lp_aiv_h1_b: "osynligt för AI?",
    lp_aiv_lead: "93% av köpbesluten börjar nu på ChatGPT, Perplexity eller Gemini. Se hur ditt varumärke rankas — och hur du kan bli nämnd på 7 dagar.",
    lp_aiv_cta: "Kör gratis AI synlighetsskanning",
    lp_out_title: "Överträffa Din Konkurrent På 30 Dagar — AI Strategi Generator | TopRankPulse",
    lp_out_desc: "Ange din domän + en konkurrent. Få en konkret 4-veckors handlingsplan (SEO + GEO) drivet av GPT — veckovisa uppgifter, orättvisa fördelar, 30-dagars prognos.",
    lp_out_h1_a: "Överträffa",
    lp_out_h1_b: "vilken konkurrent som helst",
    lp_out_h1_c: "på 30 dagar",
    lp_out_lead: "Ingen gissning. Få en personlig, AI-genererad stridsplan skräddarsydd för DIN domän jämfört med DERAS — klar på 15 sekunder.",
    lp_out_cta: "Generera min 30-dagarsplan",
    lp_scan_title: "Gratis SEO + AI Skanning — Fullständig Granskning På 30 Sekunder | TopRankPulse",
    lp_scan_desc: "Klistra in din URL → få en omedelbar SEO + GEO + AI synlighetsgranskning med 3 konkreta lösningar från PulseAI Engine™. 100% gratis, inget kreditkort.",
    lp_scan_h1_a: "Fullständig granskning på",
    lp_scan_h1_b: "30 sekunder",
    lp_scan_lead: "SEO + GEO + AI synlighet i en enda skanning. 3 kopiera-klistra-lösningar, levererade av PulseAI Engine™ på ditt språk.",
    lp_scan_cta: "Kör min gratis skanning",
  },
  no: {
    lp_aiv_title: "AI Synlighet Tracker — Bli Sitat i ChatGPT, Perplexity & Gemini | TopRankPulse",
    lp_aiv_desc: "Overvåk, mål og øk synligheten til merkevaren din i AI svarmotorer. Gratis skanning, ingen kredittkort — se hvor ofte ChatGPT nevner deg vs. konkurrentene dine.",
    lp_aiv_h1_a: "Er din merkevare",
    lp_aiv_h1_b: "usynlig for AI?",
    lp_aiv_lead: "93 % av kjøpsbeslutninger starter nå på ChatGPT, Perplexity eller Gemini. Se hvor din merkevare rangerer — og hvordan bli sitert på 7 dager.",
    lp_aiv_cta: "Kjør gratis AI synlighetskanning",
    lp_out_title: "Overgå Konkurrenten Din på 30 Dager — AI Strategigenerator | TopRankPulse",
    lp_out_desc: "Skriv inn domenet ditt + en konkurrent. Få en konkret handlingsplan for 4 uker (SEO + GEO) drevet av GPT — ukentlige oppgaver, urettferdige fordeler, 30-dagers prognose.",
    lp_out_h1_a: "Overgå",
    lp_out_h1_b: "enhver konkurrent",
    lp_out_h1_c: "på 30 dager",
    lp_out_lead: "Ingen gjetning. Få en personlig, AI-generert slagplan tilpasset DITT domene vs. DERES — klar på 15 sekunder.",
    lp_out_cta: "Generer min 30-dagers plan",
    lp_scan_title: "Gratis SEO + AI Skanning — Full Revisjon på 30 Sekunder | TopRankPulse",
    lp_scan_desc: "Lim inn URL-en din → få en øyeblikkelig SEO + GEO + AI synlighetsrevisjon med 3 konkrete løsninger fra PulseAI Engine™. 100 % gratis, ingen kredittkort.",
    lp_scan_h1_a: "Full revisjon på",
    lp_scan_h1_b: "30 sekunder",
    lp_scan_lead: "SEO + GEO + AI synlighet i en enkelt skanning. 3 kopier og lim inn-løsninger, levert av PulseAI Engine™ på ditt språk.",
    lp_scan_cta: "Kjør min gratis skanning",
  },
  da: {
    lp_aiv_title: "AI Synlighed Tracker — Bliv nævnt i ChatGPT, Perplexity & Gemini | TopRankPulse",
    lp_aiv_desc: "Overvåg, mål og øg dit brands synlighed i AI svarmaskiner. Gratis scanning, ingen kreditkort — se hvor ofte ChatGPT nævner dig i forhold til dine konkurrenter.",
    lp_aiv_h1_a: "Er dit brand",
    lp_aiv_h1_b: "usynligt for AI?",
    lp_aiv_lead: "93% af købsbeslutninger starter nu på ChatGPT, Perplexity eller Gemini. Se hvor dit brand rangerer — og hvordan du kan blive nævnt inden for 7 dage.",
    lp_aiv_cta: "Udfør gratis AI synlighedsscanning",
    lp_out_title: "Overgå din konkurrent på 30 dage — AI Strategi Generator | TopRankPulse",
    lp_out_desc: "Indtast dit domæne + en konkurrent. Få en konkret 4-ugers handlingsplan (SEO + GEO) drevet af GPT — ugentlige opgaver, uretfærdige fordele, 30-dages prognose.",
    lp_out_h1_a: "Overgå",
    lp_out_h1_b: "enhver konkurrent",
    lp_out_h1_c: "på 30 dage",
    lp_out_lead: "Ingen gætterier. Få en personlig, AI-genereret kampplan skræddersyet til DIT domæne vs. DERES — klar på 15 sekunder.",
    lp_out_cta: "Generer min 30-dages plan",
    lp_scan_title: "Gratis SEO + AI Scanning — Fuld Revision på 30 Sekunder | TopRankPulse",
    lp_scan_desc: "Indsæt din URL → få en øjeblikkelig SEO + GEO + AI synlighedsaudit med 3 konkrete rettelser fra PulseAI Engine™. 100% gratis, ingen kreditkort.",
    lp_scan_h1_a: "Fuld revision på",
    lp_scan_h1_b: "30 sekunder",
    lp_scan_lead: "SEO + GEO + AI synlighed i én enkelt scanning. 3 copy-paste rettelser, leveret af PulseAI Engine™ på dit sprog.",
    lp_scan_cta: "Udfør min gratis scanning",
  },
  fi: {
    lp_aiv_title: "AI-näkyvyysseuranta — Tule mainituksi ChatGPT:ssä, Perplexityssä & Geminissä | TopRankPulse",
    lp_aiv_desc: "Seuraa, mittaa ja kasvata brändisi näkyvyyttä AI-vastausmoottoreissa. Ilmainen skannaus, ei luottokorttia — näe kuinka usein ChatGPT mainitsee sinut verrattuna kilpailijoihisi.",
    lp_aiv_h1_a: "Onko brändisi",
    lp_aiv_h1_b: "näkyvyyden ulkopuolella AI:lle?",
    lp_aiv_lead: "93% ostopäätöksistä alkaa nyt ChatGPT:ssä, Perplexityssä tai Geminissä. Näe, missä brändisi sijoittuu — ja kuinka tulla mainituksi 7 päivässä.",
    lp_aiv_cta: "Suorita ilmainen AI-näkyvyyskanva",
    lp_out_title: "Voita kilpailijasi 30 päivässä — AI-strategiageneraattori | TopRankPulse",
    lp_out_desc: "Syötä domainisi + kilpailija. Saat konkreettisen 4 viikon toimintasuunnitelman (SEO + GEO) GPT:n tukemana — viikoittaiset tehtävät, epäreilut edut, 30 päivän ennuste.",
    lp_out_h1_a: "Voita",
    lp_out_h1_b: "mikä tahansa kilpailija",
    lp_out_h1_c: "30 päivässä",
    lp_out_lead: "Ei arvailua. Saat henkilökohtaisen, AI:n luoman taistelusuunnitelman mukautettuna OMAAN domainiisi verrattuna KILPAILIJASI — valmis 15 sekunnissa.",
    lp_out_cta: "Luo 30 päivän suunnitelmani",
    lp_scan_title: "Ilmainen SEO + AI -skannaus — Täysi tarkastus 30 sekunnissa | TopRankPulse",
    lp_scan_desc: "Liitä URL-osoitteesi → saat välittömän SEO + GEO + AI näkyvyyden tarkastuksen 3 konkreettisella korjauksella PulseAI Engine™:stä. 100% ilmainen, ei luottokorttia.",
    lp_scan_h1_a: "Täysi tarkastus",
    lp_scan_h1_b: "30 sekunnissa",
    lp_scan_lead: "SEO + GEO + AI näkyvyys yhdessä skannauksessa. 3 kopioitavaa korjausta, toimitettuna PulseAI Engine™:ltä omalla kielelläsi.",
    lp_scan_cta: "Suorita ilmainen skannaukseni",
  },
  ro: {
    lp_aiv_title: "Monitor de vizibilitate AI — Fii menționat în ChatGPT, Perplexity & Gemini | TopRankPulse",
    lp_aiv_desc: "Monitorizează, măsoară și crește vizibilitatea brandului tău în motoarele de răspuns AI. Scanare gratuită, fără card de credit — vezi cât de des te menționează ChatGPT față de concurenții tăi.",
    lp_aiv_h1_a: "Este brandul tău",
    lp_aiv_h1_b: "invizibil pentru AI?",
    lp_aiv_lead: "93% dintre deciziile de cumpărare încep acum pe ChatGPT, Perplexity sau Gemini. Vezi unde se clasează brandul tău — și cum să fii menționat în 7 zile.",
    lp_aiv_cta: "Execută scanarea gratuită",
    lp_out_title: "Depășește-ți Concurentul în 30 de Zile — Generator de Strategii AI | TopRankPulse",
    lp_out_desc: "Introdu domeniul tău + un concurent. Obține un plan concret de acțiune pe 4 săptămâni (SEO + GEO) generat de GPT — sarcini săptămânale, avantaje necorecte, prognoză pe 30 de zile.",
    lp_out_h1_a: "Depășește",
    lp_out_h1_b: "oricare concurent",
    lp_out_h1_c: "în 30 de zile",
    lp_out_lead: "Fără muncă de ghicire. Obține un plan de luptă personalizat, generat de AI, adaptat DOMEENULUI TĂU vs. AL LOR — gata în 15 secunde.",
    lp_out_cta: "Generează-mi planul pe 30 de zile",
    lp_scan_title: "Scanare SEO + AI Gratuită — Audit Complet în 30 de Secunde | TopRankPulse",
    lp_scan_desc: "Lipește URL-ul tău → obține un audit instant de vizibilitate SEO + GEO + AI cu 3 soluții concrete de la PulseAI Engine™. 100% gratuit, fără card de credit.",
    lp_scan_h1_a: "Audit complet în",
    lp_scan_h1_b: "30 de secunde",
    lp_scan_lead: "SEO + GEO + vizibilitate AI într-o singură scanare. 3 soluții copy-paste, livrate de PulseAI Engine™ în limba ta.",
    lp_scan_cta: "Execută scanarea gratuită",
  },
  bg: {
    lp_aiv_title: "Трекер за видимост на ИИ — Бъдете цитирани в ChatGPT, Perplexity & Gemini | TopRankPulse",
    lp_aiv_desc: "Следете, измервайте и увеличавайте видимостта на вашата марка в ИИ търсачките. Безплатно сканиране, без кредитна карта — вижте колко често ви споменава ChatGPT в сравнение с вашите конкуренти.",
    lp_aiv_h1_a: "Вашата марка",
    lp_aiv_h1_b: "невидима ли е за ИИ?",
    lp_aiv_lead: "93% от покупките започват сега в ChatGPT, Perplexity или Gemini. Вижте къде се нарежда вашата марка — и как да бъдете цитирани за 7 дни.",
    lp_aiv_cta: "Изпълнете безплатно сканиране на видимост",
    lp_out_title: "Превъзмогнете конкурента си за 30 дни — Генератор на ИИ стратегии | TopRankPulse",
    lp_out_desc: "Въведете домейна си + конкурент. Получете конкретен 4-седмичен план за действие (SEO + GEO), подсилен от GPT — седмични задачи, нечестни предимства, прогнозиране за 30 дни.",
    lp_out_h1_a: "Превъзмогнете",
    lp_out_h1_b: "всички конкуренти",
    lp_out_h1_c: "за 30 дни",
    lp_out_lead: "Без догадки. Получете персонализиран, генериран от ИИ стратегически план, съобразен с вашия домейн и техния — готов за 15 секунди.",
    lp_out_cta: "Генерирайте 30-дневния си план",
    lp_scan_title: "Безплатно SEO + ИИ сканиране — Пълен одит за 30 секунди | TopRankPulse",
    lp_scan_desc: "Поставете URL адреса си → получете моментален одит за SEO + GEO + ИИ видимост с 3 конкретни решения от PulseAI Engine™. 100% безплатно, без кредитна карта.",
    lp_scan_h1_a: "Пълен одит за",
    lp_scan_h1_b: "30 секунди",
    lp_scan_lead: "SEO + GEO + ИИ видимост в едно сканиране. 3 решения за копиранe и поставяне, предоставени от PulseAI Engine™ на вашия език.",
    lp_scan_cta: "Изпълнете моето безплатно сканиране",
  },
  hr: {
    lp_aiv_title: "Praćenje vidljivosti AI - Budite spominjani u ChatGPT, Perplexity i Gemini | TopRankPulse",
    lp_aiv_desc: "Pratite, mjerite i povećajte vidljivost svoje marke u AI tražilicama. Besplatno skeniranje, nema kreditne kartice - vidite koliko vas često ChatGPT spominje u usporedbi s vašim konkurentima.",
    lp_aiv_h1_a: "Je li vaša marka",
    lp_aiv_h1_b: "nevidljiva za AI?",
    lp_aiv_lead: "93% odluka o kupnji sada počinje na ChatGPT, Perplexity ili Gemini. Vidite gdje se vaša marka rangira - i kako se spomenuti u 7 dana.",
    lp_aiv_cta: "Pokrenite besplatno skeniranje vidljivosti AI",
    lp_out_title: "Nadmašite svog konkurenta u 30 dana - Generator AI strategije | TopRankPulse",
    lp_out_desc: "Unesite svoju domenu + konkurenta. Dobijte konkretan akcijski plan za 4 tjedna (SEO + GEO) podržan od GPT - tjedni zadaci, nepravedne prednosti, 30-dnevna prognoza.",
    lp_out_h1_a: "Nadmašite",
    lp_out_h1_b: "bilo kojeg konkurenta",
    lp_out_h1_c: "u 30 dana",
    lp_out_lead: "Bez nagađanja. Dobijte personalizirani, AI-generirani plan borbe prilagođen VAŠOJ domeni naspram NJIHOVOJ - spreman za 15 sekundi.",
    lp_out_cta: "Generiraj moj 30-dnevni plan",
    lp_scan_title: "Besplatno SEO + AI skeniranje - Potpuna revizija za 30 sekundi | TopRankPulse",
    lp_scan_desc: "Zalijepite svoju URL adresu → dobijte trenutnu SEO + GEO + AI vidljivost reviziju s 3 konkretna rješenja iz PulseAI Engine™. 100% besplatno, nema kreditne kartice.",
    lp_scan_h1_a: "Potpuna revizija za",
    lp_scan_h1_b: "30 sekundi",
    lp_scan_lead: "SEO + GEO + AI vidljivost u jednom skeniranju. 3 rješenja za kopiranje i lijepljenje, isporučena od PulseAI Engine™ na vašem jeziku.",
    lp_scan_cta: "Pokreni svoje besplatno skeniranje",
  },
  uk: {
    lp_aiv_title: "Трекер видимості AI — Будьте згадані в ChatGPT, Perplexity та Gemini | TopRankPulse",
    lp_aiv_desc: "Моніторте, вимірюйте та покращуйте видимість вашого бренду в AI пошукових системах. Безкоштовна перевірка, без кредитної картки — дізнайтеся, як часто вас згадує ChatGPT у порівнянні з вашими конкурентами.",
    lp_aiv_h1_a: "Чи є ваш бренд",
    lp_aiv_h1_b: "невидимим для AI?",
    lp_aiv_lead: "93% прийняття рішень про покупку починаються на ChatGPT, Perplexity або Gemini. Дізнайтеся, де знаходиться ваш бренд — і як потрапити в згадки за 7 днів.",
    lp_aiv_cta: "Запустити безкоштовну перевірку видимості AI",
    lp_out_title: "Переверште свого конкурента за 30 днів — Генератор стратегії AI | TopRankPulse",
    lp_out_desc: "Введіть ваш домен + конкурента. Отримайте конкретний 4-тижневий план дій (SEO + GEO), створений GPT — щотижневі завдання, несправедливі переваги, прогноз на 30 днів.",
    lp_out_h1_a: "Переверште",
    lp_out_h1_b: "будь-якого конкурента",
    lp_out_h1_c: "за 30 днів",
    lp_out_lead: "Жодної плутанини. Отримайте персоналізований, згенерований AI план дій, адаптований до ВАШОГО домену у порівнянні з ІХ — готовий за 15 секунд.",
    lp_out_cta: "Згенерувати мій 30-денний план",
    lp_scan_title: "Безкоштовний SEO + AI сканування — Повний аудит за 30 секунд | TopRankPulse",
    lp_scan_desc: "Вставте ваше посилання → отримайте миттєвий аудит видимості SEO + GEO + AI з 3 конкретними виправленнями від PulseAI Engine™. 100% безкоштовно, без кредитної картки.",
    lp_scan_h1_a: "Повний аудит за",
    lp_scan_h1_b: "30 секунд",
    lp_scan_lead: "SEO + GEO + видимість AI в одному скануванні. 3 простих виправлення, надані PulseAI Engine™ вашою мовою.",
    lp_scan_cta: "Запустити мою безкоштовну перевірку",
  },
  tr: {
    lp_aiv_title: "AI Görünürlük İzleyicisi — ChatGPT, Perplexity & Gemini'de Alıntılayın | TopRankPulse",
    lp_aiv_desc: "Markanızın AI yanıt motorlarındaki görünürlüğünü izleyin, ölçün ve artırın. Ücretsiz tarama, kredi kartı yok — ChatGPT'nin sizi ne sıklıkla bahsettiğine ve rakiplerinizle kıyaslayın.",
    lp_aiv_h1_a: "Markanız",
    lp_aiv_h1_b: "AI'ye görünmez mi?",
    lp_aiv_lead: "Satın alma kararlarının %93'ü artık ChatGPT, Perplexity veya Gemini'de başlıyor. Markanızın sıralamasını görün — ve 7 gün içinde alıntı almak için nasıl yapacağınızı öğrenin.",
    lp_aiv_cta: "Ücretsiz AI görünürlük taraması yap",
    lp_out_title: "Rakibinizi 30 Günde Geride Bırakın — AI Strateji Üreticisi | TopRankPulse",
    lp_out_desc: "Alan adınızı + bir rakibi girin. GPT destekli somut bir 4 haftalık eylem planı (SEO + GEO) alın — haftalık görevler, haksız avantajlar, 30 günlük tahmin.",
    lp_out_h1_a: "Rakipleri",
    lp_out_h1_b: "geçin",
    lp_out_h1_c: "30 günde",
    lp_out_lead: "Tahmine gerek yok. SİZİN alanınıza karşı KENDİ alanlarına özel, AI tarafından üretilmiş bir savaş planı alın — 15 saniyede hazır.",
    lp_out_cta: "30 günlük planımı oluştur",
    lp_scan_title: "Ücretsiz SEO + AI Taraması — 30 Saniyede Tam Denetim | TopRankPulse",
    lp_scan_desc: "URL'nizi yapıştırın → PulseAI Engine™ ile 3 somut düzeltmeyle anlık SEO + GEO + AI görünürlük denetimi alın. %100 ücretsiz, kredi kartı yok.",
    lp_scan_h1_a: "Tam denetim",
    lp_scan_h1_b: "30 saniyede",
    lp_scan_lead: "Tek bir taramada SEO + GEO + AI görünürlüğü. 3 kopyala-yapıştır düzeltme, PulseAI Engine™ tarafından dilinizde sunulmaktadır.",
    lp_scan_cta: "Ücretsiz taramamı yap",
  },
  ja: {
    lp_aiv_title: "AI可視性トラッカー — ChatGPT、Perplexity & Geminiに引用される | TopRankPulse",
    lp_aiv_desc: "AI回答エンジンでのブランドの可視性を監視、測定、向上させます。無料スキャン、クレジットカード不要 — ChatGPTがあなたをどれくらい言及するか、競合と比較して確認できます。",
    lp_aiv_h1_a: "あなたのブランドは",
    lp_aiv_h1_b: "AIに見えないのですか？",
    lp_aiv_lead: "購入決定の93％が今やChatGPT、Perplexity、またはGeminiから始まっています。あなたのブランドのランキングを確認し、7日以内に引用される方法を見つけてください。",
    lp_aiv_cta: "無料AI可視性スキャンを実行",
    lp_out_title: "30日以内に競合に勝つ — AI戦略ジェネレーター | TopRankPulse",
    lp_out_desc: "あなたのドメインと競合を入力してください。GPTによる具体的な4週間のアクションプラン（SEO + GEO）を取得 — 毎週のタスク、不公平な利点、30日間の予測。",
    lp_out_h1_a: "競合に勝つ",
    lp_out_h1_b: "すべての競合に",
    lp_out_h1_c: "30日以内に",
    lp_out_lead: "推測不要。あなたのドメイン対競合に合わせたパーソナライズされたAI生成の戦略プランを15秒で作成します。",
    lp_out_cta: "30日間のプランを生成",
    lp_scan_title: "無料SEO + AIスキャン — 30秒で完全監査 | TopRankPulse",
    lp_scan_desc: "URLを貼り付け → PulseAI Engine™から3つの具体的な修正が含まれた、即座のSEO + GEO + AI可視性監査を取得します。100％無料、クレジットカード不要。",
    lp_scan_h1_a: "30秒での",
    lp_scan_h1_b: "完全監査",
    lp_scan_lead: "1回のスキャンでSEO + GEO + AIの可視性を取得。PulseAI Engine™があなたの言語で提供する3つのコピーペースト修正。",
    lp_scan_cta: "無料スキャンを実行",
  },
  ko: {
    lp_aiv_title: "AI 가시성 추적기 — ChatGPT, Perplexity & Gemini에서 인용되기 | TopRankPulse",
    lp_aiv_desc: "AI 응답 엔진에서 브랜드의 가시성을 모니터링, 측정 및 성장시키세요. 무료 스캔, 신용 카드 불필요 — ChatGPT가 얼마나 자주 귀하를 언급하는지 vs. 경쟁업체와 비교해보세요.",
    lp_aiv_h1_a: "귀하의 브랜드는",
    lp_aiv_h1_b: "AI에 보이지 않나요?",
    lp_aiv_lead: "구매 결정의 93%가 이제 ChatGPT, Perplexity 또는 Gemini에서 시작됩니다. 귀하의 브랜드가 어디에 위치하는지 — 그리고 7일 이내에 인용받는 방법을 확인하세요.",
    lp_aiv_cta: "무료 AI 가시성 스캔 실행",
    lp_out_title: "30일 이내에 경쟁업체를 초월하세요 — AI 전략 생성기 | TopRankPulse",
    lp_out_desc: "귀하의 도메인과 경쟁업체를 입력하세요. GPT 기반의 구체적인 4주 행동 계획(SEO + GEO)을 받으세요 — 주간 작업, 불공정한 이점, 30일 예측.",
    lp_out_h1_a: "경쟁업체를 초월하세요",
    lp_out_h1_b: "어떠한 경쟁업체도",
    lp_out_h1_c: "30일 이내에",
    lp_out_lead: "추정이 필요 없습니다. 귀하의 도메인과 경쟁업체를 비교한 맞춤형 AI 생성 전투 계획을 15초 내에 받으세요.",
    lp_out_cta: "내 30일 계획 생성",
    lp_scan_title: "무료 SEO + AI 스캔 — 30초 안에 전체 감사 | TopRankPulse",
    lp_scan_desc: "URL을 붙여넣으세요 → PulseAI Engine™에서 3가지 구체적인 수정 사항과 함께 즉각적인 SEO + GEO + AI 가시성 감사를 받으세요. 100% 무료, 신용 카드 불필요.",
    lp_scan_h1_a: "30초 안에",
    lp_scan_h1_b: "전체 감사",
    lp_scan_lead: "하나의 스캔으로 SEO + GEO + AI 가시성을. 귀하의 언어로 제공되는 PulseAI Engine™의 3가지 복사-붙여넣기 수정 사항.",
    lp_scan_cta: "무료 스캔 실행",
  },
  zh: {
    lp_aiv_title: "AI可见性追踪器 — 在ChatGPT、Perplexity和Gemini中被引用 | TopRankPulse",
    lp_aiv_desc: "监控、测量并提升您品牌在AI回答引擎中的可见性。免费扫描，无需信用卡 — 查看ChatGPT提到您的频率及与竞争对手的对比。",
    lp_aiv_h1_a: "您的品牌",
    lp_aiv_h1_b: "在AI面前无形吗？",
    lp_aiv_lead: "93%的购买决策现在开始于ChatGPT、Perplexity或Gemini。查看您的品牌排名 — 以及如何在7天内被引用。",
    lp_aiv_cta: "进行免费AI可见性扫描",
    lp_out_title: "在30天内超越您的竞争对手 — AI策略生成器 | TopRankPulse",
    lp_out_desc: "输入您的域名 + 一个竞争对手。获取由GPT提供的具体4周行动计划（SEO + GEO） — 每周任务，竞争优势，30天预测。",
    lp_out_h1_a: "超越",
    lp_out_h1_b: "任何竞争对手",
    lp_out_h1_c: "在30天内",
    lp_out_lead: "无需猜测。获取一个个性化的、由AI生成的针对您域名与他们域名的战斗计划 — 15秒内准备好。",
    lp_out_cta: "生成我的30天计划",
    lp_scan_title: "免费SEO + AI扫描 — 30秒内完成全面审计 | TopRankPulse",
    lp_scan_desc: "粘贴您的网址 → 获取即时的SEO + GEO + AI可见性审计，并从PulseAI Engine™获得3个具体修复方案。100%免费，无需信用卡。",
    lp_scan_h1_a: "30秒内完成",
    lp_scan_h1_b: "全面审计",
    lp_scan_lead: "一次扫描完成SEO + GEO + AI可见性。由PulseAI Engine™以您的语言提供3个复制粘贴修复方案。",
    lp_scan_cta: "进行我的免费扫描",
  },
  hi: {
    lp_aiv_title: "AI विजिबिलिटी ट्रैकर - ChatGPT, Perplexity & Gemini में उल्लेखित हों | TopRankPulse",
    lp_aiv_desc: "अपने ब्रांड की AI उत्तर इंजन में विजिबिलिटी की निगरानी करें, मापें और बढ़ाएँ। मुफ्त स्कैन, कोई क्रेडिट कार्ड नहीं - देखें कि ChatGPT आपको और आपके प्रतिस्पर्धियों को कितनी बार उल्लेख करता है।",
    lp_aiv_h1_a: "क्या आपका ब्रांड",
    lp_aiv_h1_b: "AI के लिए अदृश्य है?",
    lp_aiv_lead: "खरीददारी के निर्णयों का 93% अब ChatGPT, Perplexity या Gemini पर शुरू होता है। देखें कि आपका ब्रांड कहाँ रैंक करता है - और 7 दिनों में कैसे उल्लेखित हों।",
    lp_aiv_cta: "मुफ्त AI विजिबिलिटी स्कैन करें",
    lp_out_title: "30 दिनों में अपने प्रतिस्पर्धी को हराएँ - AI रणनीति जनरेटर | TopRankPulse",
    lp_out_desc: "अपना डोमेन + एक प्रतिस्पर्धी दर्ज करें। GPT द्वारा समर्थित एक ठोस 4-सप्ताह की कार्रवाई योजना (SEO + GEO) प्राप्त करें - साप्ताहिक कार्य, अन्यायपूर्ण लाभ, 30-दिन की पूर्वानुमान।",
    lp_out_h1_a: "हराएँ",
    lp_out_h1_b: "किसी भी प्रतिस्पर्धी को",
    lp_out_h1_c: "30 दिनों में",
    lp_out_lead: "कोई अटकलें नहीं। आपके डोमेन के खिलाफ व्यक्तिगत, AI-जनित लड़ाई योजना प्राप्त करें - 15 सेकंड में तैयार।",
    lp_out_cta: "मेरी 30-दिन की योजना बनाएं",
    lp_scan_title: "मुफ्त SEO + AI स्कैन - 30 सेकंड में पूरी ऑडिट | TopRankPulse",
    lp_scan_desc: "अपना URL पेस्ट करें → PulseAI Engine™ से 3 ठोस सुधारों के साथ तत्काल SEO + GEO + AI विजिबिलिटी ऑडिट प्राप्त करें। 100% मुफ्त, कोई क्रेडिट कार्ड नहीं।",
    lp_scan_h1_a: "30 सेकंड में",
    lp_scan_h1_b: "पूरी ऑडिट",
    lp_scan_lead: "एक ही स्कैन में SEO + GEO + AI विजिबिलिटी। 3 कॉपी-पेस्ट सुधार, PulseAI Engine™ द्वारा आपकी भाषा में प्रदान किया गया।",
    lp_scan_cta: "मेरी मुफ्त स्कैन चलाएँ",
  },
  ar: {
    lp_aiv_title: "متعقب الظهور الذكي — كن مذكورًا في ChatGPT وPerplexity وGemini | TopRankPulse",
    lp_aiv_desc: "راقب، قس، ونمِّ ظهور علامتك التجارية في محركات إجابات الذكاء الاصطناعي. مسح مجاني، بدون بطاقة ائتمان — انظر كم مرة يذكرك ChatGPT مقارنة بمنافسيك.",
    lp_aiv_h1_a: "هل علامتك التجارية",
    lp_aiv_h1_b: "غير مرئية للذكاء الاصطناعي؟",
    lp_aiv_lead: "93% من قرارات الشراء تبدأ الآن على ChatGPT أو Perplexity أو Gemini. انظر إلى مرتبة علامتك التجارية — وكيفية الحصول على ذكر خلال 7 أيام.",
    lp_aiv_cta: "قم بتشغيل المسح المجاني لرؤية الذكاء الاصطناعي",
    lp_out_title: "تجاوز منافسك في 30 يومًا — مولد استراتيجية الذكاء الاصطناعي | TopRankPulse",
    lp_out_desc: "أدخل نطاقك + منافس. احصل على خطة عمل ملموسة لمدة 4 أسابيع (SEO + GEO) مدعومة بـ GPT — مهام أسبوعية، مزايا غير عادلة، توقع لمدة 30 يومًا.",
    lp_out_h1_a: "تجاوز",
    lp_out_h1_b: "أي منافس",
    lp_out_h1_c: "في 30 يومًا",
    lp_out_lead: "لا تخمين. احصل على خطة معركة شخصية، مولدة بالذكاء الاصطناعي، مصممة لنطاقك مقابل نطاقهم — جاهزة في 15 ثانية.",
    lp_out_cta: "قم بإنشاء خطتي لمدة 30 يومًا",
    lp_scan_title: "مسح SEO + AI مجاني — تدقيق كامل في 30 ثانية | TopRankPulse",
    lp_scan_desc: "الصق عنوان URL الخاص بك → احصل على تدقيق فوري لرؤية SEO + GEO + AI مع 3 إصلاحات ملموسة من PulseAI Engine™. 100% مجاني، بدون بطاقة ائتمان.",
    lp_scan_h1_a: "تدقيق كامل في",
    lp_scan_h1_b: "30 ثانية",
    lp_scan_lead: "رؤية SEO + GEO + AI في مسح واحد. 3 إصلاحات سهلة النسخ واللصق، مقدمة من PulseAI Engine™ بلغتك.",
    lp_scan_cta: "قم بتشغيل مسحي المجاني",
  },
  id: {
    lp_aiv_title: "Pelacak Visibilitas AI — Dikutip di ChatGPT, Perplexity & Gemini | TopRankPulse",
    lp_aiv_desc: "Pantau, ukur, dan kembangkan visibilitas merek Anda di mesin jawaban AI. Pemindaian gratis, tanpa kartu kredit — lihat seberapa sering ChatGPT menyebut Anda dibandingkan dengan pesaing Anda.",
    lp_aiv_h1_a: "Apakah merek Anda",
    lp_aiv_h1_b: "tidak terlihat oleh AI?",
    lp_aiv_lead: "93% keputusan pembelian kini dimulai di ChatGPT, Perplexity atau Gemini. Lihat peringkat merek Anda — dan cara untuk dikutip dalam 7 hari.",
    lp_aiv_cta: "Lakukan pemindaian visibilitas AI gratis",
    lp_out_title: "Menyaingi Pesaing Anda dalam 30 Hari — Generator Strategi AI | TopRankPulse",
    lp_out_desc: "Masukkan domain Anda + pesaing. Dapatkan rencana aksi konkret selama 4 minggu (SEO + GEO) yang didorong oleh GPT — tugas mingguan, keunggulan tidak adil, perkiraan 30 hari.",
    lp_out_h1_a: "Menyaingi",
    lp_out_h1_b: "pesaing mana pun",
    lp_out_h1_c: "dalam 30 hari",
    lp_out_lead: "Tanpa tebakan. Dapatkan rencana pertempuran yang dipersonalisasi, dihasilkan oleh AI, disesuaikan dengan DOMAIN Anda vs. DOMAIN MEREKA — siap dalam 15 detik.",
    lp_out_cta: "Hasilkan rencana 30 hari saya",
    lp_scan_title: "Pemindaian SEO + AI Gratis — Audit Lengkap dalam 30 Detik | TopRankPulse",
    lp_scan_desc: "Tempelkan URL Anda → dapatkan audit visibilitas SEO + GEO + AI instan dengan 3 perbaikan konkret dari PulseAI Engine™. 100% gratis, tanpa kartu kredit.",
    lp_scan_h1_a: "Audit lengkap dalam",
    lp_scan_h1_b: "30 detik",
    lp_scan_lead: "Visibilitas SEO + GEO + AI dalam satu pemindaian. 3 perbaikan salin-tempel, disampaikan oleh PulseAI Engine™ dalam bahasa Anda.",
    lp_scan_cta: "Lakukan pemindaian gratis saya",
  },
};
